import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import { useTranslation } from 'react-i18next';

// style
import styles from './style';

const useStyles = makeStyles(styles);

export default function DamLargeLegend() {
  const { t } = useTranslation();
  const classes = useStyles();

  function Row() {
    return (
      <>
        <div id="legend" style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <Grid item xs className={classes.boxLevel}>
            <Box>
              <Box p={(0.5)} className={`${classes.color} ${classes.oneLarge}`}>{'<Lower curve'}</Box>
              <Box p={(0.5)} className={classes.title}>{t('น้อยกว่าเกณฑ์')}</Box>
            </Box>
          </Grid>
          <Grid item xs className={classes.boxLevel}>
            <Box>
              <Box p={(0.5)} className={`${classes.color} ${classes.twoLarge}`}>within curve</Box>
              <Box p={(0.5)} className={classes.title}>{t('ปกติ')}</Box>
            </Box>
          </Grid>
          <Grid item xs className={classes.boxLevel}>
            <Box>
              <Box p={(0.5)} className={`${classes.color} ${classes.fourLarge}`}>{'>Upper curve'}</Box>
              <Box p={(0.5)} className={classes.title}>{t('มากกว่าเกณฑ์')}</Box>
            </Box>
          </Grid>
          <Grid item xs className={classes.boxLevel}>
            <Box>
              <Box p={(0.5)} className={`${classes.color} ${classes.fiveLarge}`}>{'>100%'}</Box>
              <Box p={(0.5)} className={classes.title}>{t('เกินความจุ')}</Box>
            </Box>
          </Grid>
        </div>
        <div id="legend" style={{ display: 'flex', flexDirection: 'row', width: '40%' }}>
          <Grid item xs className={classes.boxLevel}>
            <Box>
              <Box p={(0.5)} className={`${classes.color} ${classes.zeroLarge}`}>-</Box>
              <Box p={(0.5)} className={classes.title}>{t('ข้อมูลรอปรับปรุง / ไม่มีข้อมูลรายวัน')}</Box>
            </Box>
          </Grid>
        </div>
      </>
    );
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Row />
      </Grid>
    </div>
  );
}
